import styled from 'styled-components';

import InlineMessage from '../InlineMessage';

export const StyledInlineMessage = styled(InlineMessage)`
  font-style: italic;
  color: ${({ theme }) => theme.colors.darkestGray};
`;
